export default function initTranslationsMK() {
  const translationsMK = [
    {
      key: 'Zahlungsdaten',
      value: 'Zahlungsdaten / Податоци за плаќање'
    },
    {
      key: 'Nachname',
      value: 'Nachname \n Презиме'
    },
    {
      key: 'Vorname',
      value: 'Vorname \n Име'
    },
    {
      key: 'Geburtsdatum',
      value: 'Geburtsdatum \n Датум на раѓање'
    },
    {
      key: 'E-Mail',
      value: 'E-Mail \n Е- пошта'
    },
    {
      key: 'Zahlungsreferenz laut Zahlschein',
      value: 'Zahlungsreferenz laut Zahlschein \n Повикување на број според уплатница'
    },
    {
      key: 'Prämie laut Zahlschein',
      value: 'Prämie laut Zahlschein (EUR) \n Премија според уплатница'
    },
    {
      key: 'Zahlungsart',
      value: 'Zahlungsart / Начин на плаќање'
    },
    {
      key: 'Kreditkarte',
      value: 'Kreditkarte \n Кредитна картичка'
    },
    {
      key: 'Sofortüberweisung (Debitkarte)',
      value: 'Sofortüberweisung (Debitkarte) \n Дебитна картичка'
    },
    {
      key: 'Sie werden nach Abschluss des vollständig ausgefüllten Formulars durch Klick auf den Button "Online abschließen" zur Bezahlseite weitergeleitet, um die Zahlung per Kreditkarte durchzuführen.',
      value:
        'Sie werden nach Abschluss des vollständig ausgefüllten Formulars durch Klick auf den Button „Zahlung abschließen“ zur Bezahlseite weitergeleitet, um die Zahlung durchzuführen. \n Откако ќе го пополните формуларот во целост, со кликање на копчето „Изврши плаќање“ ќе бидете пренасочени кон страницата за плаќање за да го извршите плаќањето.'
    },
    {
      key: 'Name',
      value: 'Name \n Презиме'
    },
    {
      key: 'Zahlungsreferenz',
      value: 'Zahlungsreferenz \n Повикување на број'
    },
    {
      key: 'Prämie',
      value: 'Prämie \n Премија'
    },
    {
      key: 'Bezahlung',
      value: 'Bezahlung / Плаќање'
    },
    {
      key: 'Zahlweise',
      value: 'Zahlweise \n начин на плаќање'
    },
    {
      key: 'Online Prämienzahlung',
      value: 'Online Prämienzahlung \n онлајн плаќање на премија'
    },
    {
      key: 'Ihre Daten',
      value: 'Ihre Daten / вашите податоци'
    },
    {
      key: 'Bestätigung',
      value: 'Bestätigung / потврдa'
    },
    {
      key: 'Weiter',
      value: 'Weiter / Понатаму'
    },
    {
      key: 'Zahlung abschließen',
      value: 'Zahlung abschließen / изврши уплата'
    },
    {
      key: 'Zurück',
      value: 'Zurück / назад'
    },
    {
      key: 'Eingabe erforderlich!',
      value: 'Eingabe erforderlich! \n Задолжително венсување на податоци'
    },
    {
      key: 'Eingabewert ist keine Emailadresse!',
      value: 'Eingabewert ist keine Emailadresse! \n Внесот не е E-mail адреса'
    },
    {
      key: 'Nur Eingabe von Zahlen erlaubt!',
      value: 'Nur Eingabe von Zahlen erlaubt! \n Дозволено е внесување само на броеви'
    },
    {
      key: 'Eingabe kein gültiges Datum',
      value: 'Eingabe kein gültiges Datum \n Внесен е невалиден датум'
    },
    {
      key: 'Eingabe darf keine Zahlen enthalten!',
      value: 'Eingabe darf keine Zahlen enthalten! \n внесот не може да содржи броеви!'
    },
    {
      key: 'Eingabe muss eine Zahl mit 12 Stellen sein!',
      value: 'Eingabe muss eine Zahl mit 12 Stellen sein! \n внесување на броеви мора да биде со 12 цифри!'
    },
    {
      key: 'Ihr Online-Abschluss war erfolgreich.',
      value: 'Ihr Online-Abschluss war erfolgreich.  \n Вашата онлајн уплата е успешна.'
    },
    {
      key: 'Sie erhalten in Kürze ein Bestätigungsmail.',
      value: 'Sie erhalten in Kürze ein Bestätigungsmail. \n Наскоро ќе добиете   E-mail за потврда.'
    },
    {
      key: 'Ihr Online-Abschluss war nicht erfolgreich.',
      value: 'Ihr Online-Abschluss war nicht erfolgreich \n Вашиот онлајн формулар е неуспешен'
    },
    {
      key: 'Kreditkartenzahlung fehlgeschlagen',
      value: 'Kreditkartenzahlung fehlgeschlagen \n Вашето плаќањее неуспешно'
    }
  ];

  window.reactTranslations = window.reactTranslations || [];
  window.reactTranslations.push(...translationsMK);
}
